import { useCustom } from '@refinedev/core';
import { Card, Col, Row, Statistic, Typography } from 'antd';
import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  StarFilled,
  LikeOutlined,
} from '@ant-design/icons';
import type { ColProps } from 'antd';
import type { ReviewStatsOut } from '@/api/generated/schemas';

// Five cards don't divide the 24-column grid, so lg+ splits the row evenly.
const colProps: ColProps = { xs: 24, sm: 12, lg: { flex: '20%' } };

export const ReviewKpiCards = () => {
  const { query } = useCustom<ReviewStatsOut>({
    url: 'feedback/reviews/stats',
    method: 'get',
  });

  const stats = query.data?.data;
  const acceptancePct = stats ? Math.round(stats.acceptance_rate * 100) : 0;

  return (
    <Row gutter={[16, 16]}>
      <Col {...colProps}>
        <Card loading={query.isLoading}>
          <Statistic
            title="Recenzje ogółem"
            value={stats?.total ?? 0}
            prefix={<LikeOutlined />}
            suffix={
              stats?.reported ? (
                <Typography.Text
                  type="danger"
                  style={{ fontSize: 12, marginLeft: 4 }}
                >
                  {stats.reported} zgłoszonych
                </Typography.Text>
              ) : undefined
            }
          />
        </Card>
      </Col>

      <Col {...colProps}>
        <Card loading={query.isLoading}>
          <Statistic
            title="Oczekujące"
            value={stats?.pending ?? 0}
            prefix={<ClockCircleOutlined />}
            valueStyle={{
              color: (stats?.pending ?? 0) > 0 ? '#d46b08' : undefined,
            }}
            suffix={
              stats?.accepted != null ? (
                <Typography.Text
                  type="secondary"
                  style={{ fontSize: 12, marginLeft: 4 }}
                >
                  {stats.accepted} zaakceptowanych
                </Typography.Text>
              ) : undefined
            }
          />
        </Card>
      </Col>

      <Col {...colProps}>
        <Card loading={query.isLoading}>
          <Statistic
            title="Odrzucone"
            value={stats?.rejected ?? 0}
            prefix={<CloseCircleOutlined />}
          />
        </Card>
      </Col>

      <Col {...colProps}>
        <Card loading={query.isLoading}>
          <Statistic
            title="Wskaźnik akceptacji"
            value={acceptancePct}
            prefix={<CheckCircleOutlined />}
            suffix="%"
            valueStyle={{ color: acceptancePct >= 50 ? '#3f8600' : '#cf1322' }}
          />
        </Card>
      </Col>

      <Col {...colProps}>
        <Card loading={query.isLoading}>
          <Statistic
            title="Średnia ocena"
            value={
              stats?.avg_rating != null ? stats.avg_rating.toFixed(1) : '—'
            }
            prefix={<StarFilled style={{ color: '#faad14' }} />}
            suffix={stats?.avg_rating != null ? '/ 5' : undefined}
          />
          {stats?.avg_acceptance_latency_hours != null && (
            <Typography.Text
              type="secondary"
              style={{ fontSize: 12, display: 'block', marginTop: 4 }}
            >
              Śr. czas moderacji:{' '}
              {stats.avg_acceptance_latency_hours.toFixed(1)}h
            </Typography.Text>
          )}
        </Card>
      </Col>
    </Row>
  );
};
